import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMeasure } from 'react-use';

export const SubHeaderLeft = ({ children, className }) => {
	return <div className={classNames('subheader-left', 'col-sm', className)}>{children}</div>;
};
SubHeaderLeft.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
SubHeaderLeft.defaultProps = {
	className: null,
};

export const SubHeaderRight = ({ children, className, style }) => {
	return (
		<div className={classNames('subheader-right', 'col-sm-auto', className)} style={style}>
			{children}
		</div>
	);
};
SubHeaderRight.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	style: PropTypes.object,
};
SubHeaderRight.defaultProps = {
	className: null,
	style: undefined,
};

export const SubheaderSeparator = ({ className }) => {
	return <div className={classNames('subheader-separator', className)} />;
};
SubheaderSeparator.propTypes = {
	className: PropTypes.string,
};
SubheaderSeparator.defaultProps = {
	className: null,
};

const SubHeader = ({ children, className, style }) => {
	const [ref, { height }] = useMeasure();

	const root = document.documentElement;
	// root.style.setProperty('--subheader-height', `${height}px`);

	useLayoutEffect(() => {
		document.body.classList.add('subheader-enabled');
		return () => {
			document.body.classList.remove('subheader-enabled');
		};
	});

	return (
		<div
			ref={ref}
			className={classNames('subheader', 'row', className)}
			style={{
				borderRadius: '10px',
				// marginLeft: '0.25rem',
				// marginRight: '0.25rem',
				paddingTop: '0.25rem',
				paddingBottom: '0.25rem',
				...style,
			}}>
			{children}
		</div>
	);
};
SubHeader.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	style: PropTypes.object,
};
SubHeader.defaultProps = {
	className: null,
	style: undefined,
};

export default SubHeader;
